module.exports = __webpack_public_path__ + "images/top.82ea278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/top.png
// module id = lUTn
// module chunks = 19